<script>
    import Button from 'views/components/button/Button.svelte'

    let {
        // Use value to bind to. If the input is valid, it will be a number. Otherwise, it will be NaN
        value = $bindable(),
        step = 1,
        min = 0,
        max = null,
        showStepperButtons = true,
        label = '',
        onPressEnterCallback = null
    } = $props()

    const initialValue = value
    let inputElement
    const cid = _.uniqueId()

    export function getValue() {
        return value
    }

    export function setValue(newValue) {
        inputElement.value = newValue
        onInput()
    }

    function onInput() {
        inputElement.checkValidity() ? value = inputElement.valueAsNumber : value = null
    }

    function onKeyUp(event) {
        if (onPressEnterCallback && event.key === 'Enter') {
            event.preventDefault()
            onPressEnterCallback(value)
        }
    }

    function onWheel(event) {
        // Prevent accidentally changing the value by scrolling
        event.preventDefault()
    }

    function doStep(isUpwards) {
        isUpwards ? inputElement.stepUp() : inputElement.stepDown()
        onInput()
    }
</script>

{#if label}
    <label class="label" for={cid}>{label}</label>
{/if}

<div class="input-container">
    {#if showStepperButtons}
        <Button label="-" theme="secondary" callback={() => doStep(false)}></Button>
    {/if}

    <input
        bind:this={inputElement}
        type="number"
        class="input-field"
        id={cid}
        value={initialValue}
        {min}
        {max}
        {step}
        oninput={onInput}
        onkeyup={onKeyUp}
        onwheel={onWheel}
    />

    {#if showStepperButtons}
        <Button label="+" theme="secondary" callback={() => doStep(true)}></Button>
    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.label {
  font-size: 14px;
  font-variant-caps: all-small-caps;
  letter-spacing: 1px;
  line-height: 12px;
  color: hsl(205, 60%, 44%);
  display: block;
  margin-bottom: 8px;
  color: hsl(205, 60%, 44%);
}

.input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.input-container .input-field {
  border-radius: 16px;
  padding: 14px 16px;
  border: solid 1px hsl(40, 4%, 84%);
  background-color: #fff;
  font-size: 16px;
}
.input-container .input-field:focus-within {
  border-color: hsl(205, 60%, 44%);
  outline: none;
}
.input-container .input-field {
  appearance: textfield;
  text-align: center;
  padding-left: 4px;
  padding-right: 4px;
  width: 64px;
}
.input-container .input-field::-webkit-inner-spin-button, .input-container .input-field::-webkit-outer-spin-button {
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: none;
  margin: 0;
}
.input-container .input-field:invalid {
  border-color: #fc7787;
}</style>
